module.exports = __webpack_public_path__ + "static/media/down-red.e4295e0b.svg";